import React, { useState } from "react";

// Grid de avatares seleccionables (catálogo con foto) para armar una escena en modo Manual
export const RSAvatarPicker = ({ avatares, value, onChange }) => {
    const [avatarPreview, setAvatarPreview] = useState(null);

    const verFoto = (e, avatar) => {
        e.stopPropagation();
        setAvatarPreview(avatar);
    };

    return (
        <div className="rs-avatar-grid">
            {avatares.length === 0 && (
                <span className="rs-avatar-grid__vacio">Sin avatares disponibles</span>
            )}

            {avatares.map((a) => (
                <div
                    key={a.avatar_Id}
                    className={`rs-avatar-card ${value === a.avatar_Id ? "selected" : ""}`}
                    onClick={() => onChange(a.avatar_Id)}
                >
                    <div className="rs-avatar-card__foto-wrap">
                        {a.foto ? (
                            <img className="rs-avatar-card__foto" src={a.foto} alt={a.nombre} />
                        ) : (
                            <span className="rs-avatar-card__placeholder">👤</span>
                        )}

                        {a.foto && (
                            <button
                                type="button"
                                className="rs-avatar-card__ojo"
                                title="Ver imagen completa"
                                onClick={(e) => verFoto(e, a)}
                            >
                                👁
                            </button>
                        )}
                    </div>
                    <span className="rs-avatar-card__nombre">{a.nombre}</span>
                </div>
            ))}

            {avatarPreview && (
                <div className="rs-modal-overlay" onClick={() => setAvatarPreview(null)}>
                    <div className="rs-avatar-preview" onClick={e => e.stopPropagation()}>
                        <button className="rs-modal__close" onClick={() => setAvatarPreview(null)}>✕</button>
                        <img src={avatarPreview.foto} alt={avatarPreview.nombre} />
                        <span className="rs-avatar-preview__nombre">{avatarPreview.nombre}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RSAvatarPicker;